import React from "react";
import AdCarousel from "../../components/Client/AdCarousel";

export default function MainPage() {
  return (
    <div>
      <AdCarousel />
    </div>
  );
}
